import { AlertsPopover } from "@hydrologiq/shared/components/alerts"
import { useStableAlerts } from "@hydrologiq/shared/hooks/useStableAlerts"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"

interface CustomerAlertsPopupProps {
  customer: gqlTypes.Customer
  alertCount: number
}

function CustomerAlertsPopup({ customer, alertCount }: CustomerAlertsPopupProps) {

  const alerts = customer?.alerts || []
  const stableAlerts = useStableAlerts(alerts)
  return (
    <AlertsPopover
      alerts={stableAlerts}
      totalCount={alertCount}
      triggerLabel={customer.name}
      context={{ customer: customer.id }}
    />
  )
}

export default CustomerAlertsPopup
